// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__C_eu-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1ETy-"};